import { ResponsiveSelect } from "../../../../../components/MobileForm";
import { InlineToggle } from "../../../../../components/InlineToggle";
import {
  SORT_OPTIONS,
  sortStateToValue,
  valueToSortState,
} from "../SavingsHoldings";
import { CountLabel, LeftGroup, SelectField, Wrapper } from "./styles";
import { SavingsFiltersProps } from "./types";

export const SavingsFilters: React.FC<SavingsFiltersProps> = ({
  variant,
  isCompact,
  periodValue,
  periodOptions,
  onPeriodChange,
  activeOnly,
  onActiveOnlyChange,
  count,
  total,
  showSort,
  sort,
  onSortChange,
}) => {
  const showCount = variant === "inline";
  const renderSort = showSort && variant === "standalone";
  const countLabel = `${count} of ${total} ${total === 1 ? "saving" : "savings"}`;

  const sortValue = sortStateToValue(sort);

  return (
    <Wrapper $variant={variant}>
      <LeftGroup $variant={variant}>
        <SelectField>
          <ResponsiveSelect
            isCompact={isCompact}
            options={periodOptions}
            value={periodValue}
            onChange={(option) => onPeriodChange(option.value)}
            sheetTitle="Select period"
            testId="savings-period-filter"
          />
        </SelectField>

        <InlineToggle
          checked={activeOnly}
          onChange={onActiveOnlyChange}
          label="Active only"
          accent="success"
          ariaLabel="Show active savings only"
          testId="savings-active-only-filter"
        />
      </LeftGroup>

      {renderSort && (
        <ResponsiveSelect
          isCompact={isCompact}
          options={SORT_OPTIONS}
          value={sortValue}
          onChange={(option) => onSortChange(valueToSortState(option.value))}
          sheetTitle="Sort by"
          testId="savings-period-sort"
        />
      )}
      {showCount && <CountLabel>{countLabel}</CountLabel>}
    </Wrapper>
  );
};
